import api from "./api";

// Perfil publico do talento (recrutei-api, modulo ProfilePages).
// Contrato: CONTRATO.md da branch feature/perfil-publico.
const BASE = "api/v2/talents/profile-page";

// As respostas vem no envelope { data } do projeto; aceitamos tambem o corpo cru.
function unwrap(response) {
  const body = response && response.data;
  if (body && Object.prototype.hasOwnProperty.call(body, "data")) return body.data;
  return body;
}

export const PROFILE_URL = (
  process.env.VUE_APP_PROFILE_URL || "https://recrutei.me"
).replace(/\/+$/, "");

export function profileOrigin() {
  try {
    return new URL(PROFILE_URL).origin;
  } catch (e) {
    return PROFILE_URL;
  }
}

export function pdfUrl(slug) {
  return `${PROFILE_URL}/${encodeURIComponent(slug)}/curriculo`;
}

export function templatePreviewUrl(template) {
  return `${PROFILE_URL}/modelos/${encodeURIComponent(template)}`;
}

// base64url de um JSON com acentos (btoa sozinho so aceita latin1).
export function base64UrlJson(value) {
  const json = JSON.stringify(value);
  return btoa(unescape(encodeURIComponent(json)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

// Previa do editor: o front publico renderiza no servidor, entao as escolhas
// ainda nao salvas vao na URL (`o`) e `v` muda a cada PUT salvo (itens escondidos
// e dados que a previa busca na API so valem depois de salvos).
export function editorPreviewUrl(token, overrides, version = 0) {
  const params = [];
  if (overrides) params.push(`o=${base64UrlJson(overrides)}`);
  params.push(`v=${encodeURIComponent(version)}`);
  return `${PROFILE_URL}/previa-editor/${encodeURIComponent(token)}?${params.join("&")}`;
}

// Motivo de erro que a API devolve em 402/409/429 etc.
export function errorReason(error) {
  const data = error && error.response && error.response.data;
  if (!data) return null;
  return data.reason || (data.data && data.data.reason) || null;
}

export function errorStatus(error) {
  return (error && error.response && error.response.status) || null;
}

export default {
  async show() {
    return unwrap(await api.get(BASE));
  },
  async update(payload) {
    return unwrap(await api.put(BASE, payload));
  },
  async analytics(days = 30) {
    return unwrap(await api.get(`${BASE}/analytics`, { params: { days } }));
  },
  async slugAvailability(slug) {
    return unwrap(await api.get(`${BASE}/slug-availability`, { params: { slug } }));
  },
  async changeSlug(slug) {
    return unwrap(await api.put(`${BASE}/slug`, { slug }));
  },
  async publish() {
    return unwrap(await api.post(`${BASE}/publish`));
  },
  async unpublish() {
    return unwrap(await api.post(`${BASE}/unpublish`));
  },
  async destroy() {
    return unwrap(await api.delete(BASE));
  },
  async previewToken() {
    return unwrap(await api.get(`${BASE}/preview-token`));
  },
  async billingInfo() {
    return unwrap(await api.get(`${BASE}/billing-info`));
  },
  async updateBillingInfo(payload) {
    return unwrap(await api.put(`${BASE}/billing-info`, payload));
  },
  async checkout(plan, label) {
    return unwrap(await api.post(`${BASE}/checkout`, { plan, label }));
  },
  async checkoutStatus(sessionId) {
    return unwrap(
      await api.get(`${BASE}/checkout/status`, { params: { session_id: sessionId } })
    );
  },
  async billingPortal(label) {
    return unwrap(await api.post(`${BASE}/billing-portal`, { label }));
  },
};
